import { createBrowserRouter } from "react-router-dom";
import BIMViewer from "./Viewer/BimViewer";
import { Box } from "@mui/material";
import Login from "./Auth/LoginScene";
import UserLayout from "./Layout/UserLayout";
import AdminScene from "./Users/AdminScene";
import ProjectList from "./Projects/ProjectList";
import ProjectDetail from "./Projects/ProjectDetail";
import ProjectLayout from "./Layout/ProjectLayout";
import ProjectFiles from "./Files/ProjectFiles";
import ProjectClientOffer from "./Projects/ProjectClientOffer";
import ProjectBudget from "./Projects/ProjectBudget";
import ProjectUsers from "./Projects/Components/ProjectUsers";
import ProjectInternalOfferWrapper from "./Projects/ProjectInternalOfferWrapper";

const router = createBrowserRouter([
    {
        path: "/",
        element: <Login />,

    },
    {
        path: "/nabidka/:code",
        element: <ProjectClientOffer clientSide />,
    },
    {
        path: "/logged",
        element: <UserLayout />,
        children: [
            {
                path: "projects",
                element: <ProjectList />,
            },
            {
                path: "projects/:id",
                element: <ProjectLayout />,
                children: [
                    {
                        path: "detail",
                        element: <ProjectDetail />,
                    },
                    {
                        path: "viewer",
                        element: <BIMViewer />,
                    },
                    {
                        path: "viewer/:models",
                        element: <BIMViewer />,
                    },
                    {
                        path: "files",
                        element: <ProjectFiles />,
                    },

                    {
                        path: "offer-admin",
                        element: <ProjectInternalOfferWrapper />,
                    },
                    {
                        path: "budget",
                        element: <ProjectBudget />
                    },
                    {
                        path: "users",
                        element: <ProjectUsers />
                    }
                ]
            },

            {
                path: "admin",
                element: <AdminScene />,
            },
        ]
    }

]);
export default router;